function pickFirst(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
}

function normalize(value) {
  return String(value || '').trim();
}

export function buildProfileEditForm(profile) {
  const source = profile?.source || profile || {};

  return {
    firstName: normalize(pickFirst(source.firstName, source.first_name)),
    lastName: normalize(pickFirst(source.lastName, source.last_name)),
    phone: '',
    country: normalize(pickFirst(source.country, source.countryName, source.country_name)),
    language: normalize(source.language),
  };
}

export function buildProfileUpdatePayload(original, current) {
  return ['firstName', 'lastName', 'phone', 'country', 'language'].reduce((payload, field) => {
    const nextValue = normalize(current?.[field]);
    if (nextValue !== normalize(original?.[field])) {
      payload[field] = nextValue || null;
    }
    return payload;
  }, {});
}

export function validateEmailChangeForm(form) {
  const errors = {};
  const email = normalize(form?.email);
  const reason = normalize(form?.reason);

  if (!email) {
    errors.email = 'Email is required.';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = 'Enter a valid email address.';
  }

  if (!reason) {
    errors.reason = 'Reason is required.';
  }

  return errors;
}
